import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
const benefitRows = [['✅ 6 Tomes Premium Illustrés', '✅ 5 Bonus Cliniques OFFERTS'], ['✅ Schémas de Constellation Illustrés', '✅ 84 Cartes de Phrases de Guérison'], ['✅ Modèles de Génogramme Professionnels', '✅ Journal d’Intégration de 30 Jours']];
const mockupUrl = 'https://cdn.magicpatterns.com/uploads/rE7ukT1rZCPCJEg48ETJ77/MOCKUP_CONS_(FR).png';
export function Hero() {
  return <>
      <section className="w-full bg-mist px-4 py-4 text-navy sm:py-6" data-id="element-108" data-mp="xanqi48sjphh">
        <div className="mx-auto max-w-5xl text-center" data-id="element-109" data-mp="x8bcg265lz9p">
          <motion.span initial={{
          opacity: 0,
          y: -10
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.45
        }} className="inline-flex rounded-full border border-amber/50 bg-surface px-4 py-1.5 text-[10px] font-bold uppercase tracking-[0.12em] text-amber" data-id="element-110" data-mp="sa9slf0wlvx6">
            Guérison Familiale Systémique
          </motion.span>
          <motion.h1 initial={{
          opacity: 0,
          y: 18
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.55,
          delay: 0.05
        }} className="mx-auto mt-3 max-w-2xl font-serif text-3xl leading-[1.02] tracking-tight text-navy sm:text-[2.75rem]" data-id="element-111" data-mp="3j8977bv8e9p0">
            Système des Constellations Familiales™
          </motion.h1>
          <motion.p initial={{
          opacity: 0,
          y: 18
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.55,
          delay: 0.16
        }} className="mx-auto mt-3 max-w-xl text-sm leading-snug text-slate sm:text-base" data-id="element-112" data-mp="30ib0az366mmy">
            Des outils prêts à l’emploi pour comprendre vos schémas familiaux, libérer les héritages du passé et écrire
            une nouvelle histoire...
          </motion.p>
          <motion.div initial={{
          opacity: 0,
          y: 18
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.55,
          delay: 0.2
        }} className="mx-auto mt-5 max-w-3xl text-center" data-id="element-113" data-mp="2hkgl23bg7ew4">
            <p className="text-xs font-bold uppercase tracking-[0.12em] text-amber" data-id="element-114" data-mp="s3usu27hfid9">
              📦 Tout ce que vous recevez instantanément
            </p>
            <div className="mt-2 space-y-1 text-[10px] font-medium leading-snug text-slate sm:text-xs" data-id="element-115" data-mp="id03uq2uq4o4">
              {benefitRows.map(row => <p key={row.join('-')} className="flex flex-wrap items-center justify-center gap-x-4 gap-y-1" data-id="element-116" data-mp="1b0vupe5qp2cz">
                  {row.map(benefit => <span key={benefit} className="whitespace-nowrap" data-id="element-117" data-mp="162capjapi0n9">
                      {benefit}
                    </span>)}
                </p>)}
            </div>
          </motion.div>
          <motion.div initial={{
          opacity: 0,
          y: 16
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.55,
          delay: 0.26
        }} className="mx-auto mt-5 max-w-3xl" data-id="element-118" data-mp="x37ewkqj4les">
            <img src={mockupUrl} alt="Le Système des Constellations Familiales™ : la collection complète, ses 6 tomes, les outils de génogramme et les guides d’exercices" className="mx-auto block h-auto w-full max-w-2xl rounded-3xl object-contain shadow-elevated" data-id="element-119" data-mp="1x9kwertfdeju" />
          </motion.div>
          <motion.div initial={{
          opacity: 0,
          y: 12
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: 0.32
        }} className="mt-5" data-id="element-120" data-mp="2b1hgq9ouqk5o">
            <CTAButton href="#collection-complete" pulse size="large" data-id="element-121" data-mp="2kxc7js38bljj">
              ⚡ ACCÈS INSTANTANÉ
            </CTAButton>
            <p className="mx-auto mt-3 max-w-3xl text-xs leading-relaxed text-slate sm:text-sm" data-id="element-122" data-mp="2oyo128p84qx0">
              📄 PDF Haute Qualité <span className="mx-1" data-id="element-123" data-mp="umpr24j3br02">·</span> 🖨️ Ressources Imprimables <span className="mx-1" data-id="element-124" data-mp="uoaj9nhxmxur">·</span>{' '}
              ⚡ Téléchargement Immédiat <span className="mx-1" data-id="element-125" data-mp="zmc3ibr3h37t">·</span> 🔒 Paiement Sécurisé <span className="mx-1" data-id="element-126" data-mp="4bdwfeqaa7o3">·</span>{' '}
              🛡️ Protection d’Achat de 7 Jours
            </p>
          </motion.div>
        </div>
      </section>
      <section className="border-y border-amber/40 bg-surface px-4 py-5 text-navy" data-id="element-127" data-mp="3vh5owkrj9we2">
        <div className="mx-auto max-w-3xl text-center" data-id="element-128" data-mp="e88ww364ai50">
          <p className="text-sm font-bold sm:text-base" data-id="element-129" data-mp="9aqkg2sw5ks9">
            🚀 Offre de lancement active — Les 5 Bonus Cliniques offerts avec votre achat
          </p>
          <div className="mx-auto mt-3 h-2 max-w-xl overflow-hidden rounded-full bg-amber/20" data-id="element-130" data-mp="3hqjz0c3nwm6o">
            <div className="h-full w-[72%] rounded-full bg-amber" data-id="element-131" data-mp="3ct0n3iufslhw" />
          </div>
          <p className="mt-2 text-xs font-medium text-slate" data-id="element-132" data-mp="3rgvfsz8g2puz">72% des places de lancement déjà revendiquées</p>
        </div>
      </section>
    </>;
}